module.exports = __webpack_public_path__ + "static/media/list-bg3.9c4d82ae.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/images/list-bg3.jpg
// module id = 325
// module chunks = 0